import { useEffect, useRef } from 'react';

/**
 * It will eagerly load more data by PRELOAD_OFFSET pixels before reaching the end of the page.
 * This will mean that people might not even notice that the page is loading more data unless scrolling aggressively.
 */
const PRELOAD_OFFSET = 500;

export const useNarrativeCommunityScroll = (
  callback: () => Promise<unknown>
) => {
  const isLoadingRef = useRef(false);
  useEffect(() => {
    const handleScroll = async () => {
      if (isLoadingRef.current) return;
      if (
        window.innerHeight + window.scrollY + PRELOAD_OFFSET >=
        document.body.scrollHeight
      ) {
        isLoadingRef.current = true;
        await callback();
        isLoadingRef.current = false;
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [callback]);
};
